import React from 'react'
import {Dialog, DialogContent, Button, DialogActions} from '@material-ui/core';

export const BookingCancelConfirmDialog = ({open, handleCancel, handleOk}) => (
    <Dialog
        sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: 435}}}
        maxWidth="xs"
        open={open}
    >
        <DialogContent dividers>
            Точно хотите отменить бронирование?
        </DialogContent>
        <DialogActions>
            <Button
                onClick={handleCancel}
                variant="outlined"
                className="dialog-cancel"
            >
                Нет, я передумал
            </Button>
            <Button
                variant="outlined"
                onClick={handleOk}
                className="dialog-confirm"
            >
                Да, отменить
            </Button>
        </DialogActions>
    </Dialog>
);



